import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Logo } from "./Logo";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const AuthCallback = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { navigate("/login"); return; }
    const sessionId = match[1];
    const role = sessionStorage.getItem("auth_role") || "kantoor";
    sessionStorage.removeItem("auth_role");

    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId, role });
        setUser(res.data.user);
        window.history.replaceState({}, document.title, window.location.pathname);
        const pendingKlantId = sessionStorage.getItem("pending_klant_id");
        if (pendingKlantId && res.data.user.role === "klant") {
          sessionStorage.removeItem("pending_klant_id");
          try { await api.post(`/klanten/me/claim/${pendingKlantId}`); } catch {}
        }
        const dest = res.data.user.role === "klant" ? "/mijn-matches" : "/dashboard";
        navigate(dest);
      } catch (e) {
        console.error("Session exchange failed", e);
        navigate("/login");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-6 bg-[#F8FAFC]">
      <Logo size="lg" />
      <div className="flex items-center gap-3 text-slate-600">
        <div className="w-5 h-5 border-2 border-[#F5A623] border-t-transparent rounded-full animate-spin" />
        <span>{t("auth_callback.logging_in")}</span>
      </div>
    </div>
  );
};
